import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { CompletedView } from "./view";
import { useDispatch, useSelector } from "react-redux";
import { quoteAll, quoteAllClearData, } from "../../../store/generateQuote/actions";
import { executeReports, executeReportsClearData, } from "../../../store/reports/actions";
import LocalStorageService from "../../../services/localStorage";
import { useNavigate, useParams } from "react-router-dom";
import { formattedDate, formattedDateWithTime } from "../../../utils/date";
import { downloadReports } from "../../../fnx/reportsDowload";
import { getExportConfig, getReportTitle, } from "./completedDTO";
import showToast from "../../../services/toast";
import { Branches } from "../../../store/branches/actions";
import { useProjectsByCustomerId } from "../../../fnx/projectsByCustomerId";
import { showErrorToast } from "../../../fnx/showError";
import { useTranslation } from "react-i18next";
import { getCatalogStatusQuote, getCatalogStatusQuoteClearData, } from "../../../store/catalog/actions";
import { AlertLoadingHeader } from "../../../components/alertLoadingComponent/alertLoading";
import { getQuoteList } from "../../../utils/normalizeQuoteResponse";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
var FIRST_FEE_REPORT_ID = "b7147547-893a-4161-805d-0810dfe3dd04";
var TRAVEL_ASSISTANCE_REPORT_ID = "5d27b544-cd22-49d1-afff-61666d1b14bd";
var HEALTH_PREFERENTIAL_REPORT_ID = "5015ccf0-faeb-4693-83a3-64b5e986929b";
var UPCOMING_CANCELLATIONS_REPORT_ID = "6270c849-d3cd-489b-bf31-eba6e92e43dc";
var BALANCE_AGING_REPORT_ID = "42b61ae0-ab91-4987-b6d6-a4d51ed442f1";
var resolveReportTypeFromPath = function () {
    var pathname = window.location.pathname;
    if (pathname.includes("/report/first-fee"))
        return "first-fee";
    if (pathname.includes("/report/travel-assistance"))
        return "travel-assistance";
    if (pathname.includes("/report/health-preferential"))
        return "health-preferential";
    if (pathname.includes("/report/upcoming-cancellations"))
        return "upcoming-cancellations";
    if (pathname.includes("/report/balance-aging"))
        return "balance-aging";
    return "sales";
};
var isExecuteReportType = function (type) {
    return type === "first-fee" ||
        type === "travel-assistance" ||
        type === "health-preferential" ||
        type === "upcoming-cancellations" ||
        type === "balance-aging";
};
var getExecuteReportId = function (type) {
    if (type === "travel-assistance")
        return TRAVEL_ASSISTANCE_REPORT_ID;
    if (type === "health-preferential")
        return HEALTH_PREFERENTIAL_REPORT_ID;
    if (type === "upcoming-cancellations")
        return UPCOMING_CANCELLATIONS_REPORT_ID;
    if (type === "balance-aging")
        return BALANCE_AGING_REPORT_ID;
    return FIRST_FEE_REPORT_ID;
};
var toApiDate = function (isoDate) { return isoDate.split("T")[0]; };
var defaultApiStartDate = function () {
    var d = new Date();
    d.setFullYear(d.getFullYear() - 1);
    return d.toISOString().split("T")[0];
};
var defaultApiEndDate = function () { return new Date().toISOString().split("T")[0]; };
export var Completed = function () {
    var id = useParams().id;
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var reportType = resolveReportTypeFromPath();
    var _a = getExportConfig(reportType), fields = _a.fields, labelFields = _a.labelFields;
    var isInitialMount = React.useRef(true);
    var _b = React.useState(true), enable = _b[0], setEnable = _b[1];
    var _c = React.useState(1), page = _c[0], setPage = _c[1];
    var _d = React.useState(5000), limit = _d[0], setLimit = _d[1];
    var _e = useState([]), rows = _e[0], setRows = _e[1];
    var _f = React.useState(""), startDate = _f[0], setStartDate = _f[1];
    var _g = React.useState(""), endDate = _g[0], setEndDate = _g[1];
    var _h = React.useState(false), isLoadin = _h[0], setIsLoading = _h[1];
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var _j = useState(""), nameSearch = _j[0], setNameSearch = _j[1];
    var _k = useState(""), description = _k[0], setDescription = _k[1];
    var _l = useState([]), branchesOptions = _l[0], setBranchesOptions = _l[1];
    var _m = useState([]), insuranceOptions = _m[0], setInsuranceOptions = _m[1];
    var _o = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _o[0], setSeeToast = _o[1];
    var idSalesCompleted = "99d9c7f3-e138-4a36-920b-1de59346ea10";
    var idSalesCanceled = "d40de8d2-f71a-42e7-98b2-b30efa6b153a";
    var _p = React.useState(""), sponsorId = _p[0], setSponsorId = _p[1];
    var _q = useState(false), trigger = _q[0], setTrigger = _q[1];
    var responseInsurance = useProjectsByCustomerId(clientId, trigger, "", "", sponsorId).responseInsurance;
    var _r = useSelector(function (state) { return ({
        responseAllQuote: state.Quote.responseAllQuote,
        errorAllQuote: state.Quote.errorAllQuote,
        loadingAllQuote: state.Quote.loadingAllQuote,
    }); }), responseAllQuote = _r.responseAllQuote, errorAllQuote = _r.errorAllQuote, loadingAllQuote = _r.loadingAllQuote;
    var _s = useSelector(function (state) {
        var _a;
        return ({
            responseBranches: (_a = state.Branches.responseBranches) === null || _a === void 0 ? void 0 : _a.data,
            errorBranches: state.Branches.errorBranches,
            loadingBranches: state.Branches.loadingBranches,
        });
    }), responseBranches = _s.responseBranches, errorBranches = _s.errorBranches, loadingBranches = _s.loadingBranches;
    var _t = useSelector(function (state) {
        var _a;
        return ({
            responseGetCatalogStatusQuote: (_a = state.Catalog.responseGetCatalogStatusQuote) === null || _a === void 0 ? void 0 : _a.data,
            errorGetCatalogStatusQuote: state.Catalog.errorGetCatalogStatusQuote,
            loadingGetCatalogStatusQuote: state.Catalog.loadingGetCatalogStatusQuote,
        });
    }), responseGetCatalogStatusQuote = _t.responseGetCatalogStatusQuote, errorGetCatalogStatusQuote = _t.errorGetCatalogStatusQuote, loadingGetCatalogStatusQuote = _t.loadingGetCatalogStatusQuote;
    var _u = useSelector(function (state) {
        var _a;
        return ({
            responseExecuteReports: (_a = state.Reports.responseExecuteReports) === null || _a === void 0 ? void 0 : _a.data,
            errorExecuteReports: state.Reports.errorExecuteReports,
            loadingExecuteReports: state.Reports.loadingExecuteReports,
        });
    }), responseExecuteReports = _u.responseExecuteReports, errorExecuteReports = _u.errorExecuteReports, loadingExecuteReports = _u.loadingExecuteReports;
    var loadExecuteReportData = function (startDate, endDate) {
        if (startDate === void 0) { startDate = ""; }
        if (endDate === void 0) { endDate = ""; }
        dispatch(executeReports({
            id: getExecuteReportId(reportType),
            fkClientId: clientId,
            params: {
                FechaInicio: startDate ? toApiDate(startDate) : defaultApiStartDate(),
                FechaFin: endDate ? toApiDate(endDate) : defaultApiEndDate(),
            },
            page: 1,
            pageSize: limit,
        }));
    };
    useEffect(function () {
        if (reportType !== "sales")
            return;
        var description1 = '"Si desea aplicar un filtro al resultado de ventas completadas, seleccione el filtro deseado que se muestra a continuación."';
        var description2 = "Si desea aplicar un filtro al resultado de ventas canceladas, seleccione el filtro deseado que se muestra a continuación.";
        var description3 = "Si desea aplicar un filtro al resultado de ventas completadas y canceladas, seleccione el filtro deseado que se muestra a continuación.";
        var foundItem = responseGetCatalogStatusQuote === null || responseGetCatalogStatusQuote === void 0 ? void 0 : responseGetCatalogStatusQuote.find(function (item) { return item.id === id; });
        if (foundItem && foundItem.description === "Emitida") {
            setDescription(description1);
        }
        else if (foundItem && foundItem.description === "Cancelada") {
            setDescription(description2);
        }
        else {
            setDescription(description3);
        }
    }, [responseGetCatalogStatusQuote, id]);
    useEffect(function () {
        setDescription("");
        if (!responseBranches) {
            dispatch(Branches({
                enable: enable,
                page: page,
                limit: limit,
                clientId: clientId,
            }));
        }
        if (isExecuteReportType(reportType)) {
            loadExecuteReportData();
        }
        else {
            if (!responseAllQuote) {
                getQuoteAll();
            }
            if (!responseGetCatalogStatusQuote && reportType === "sales") {
                dispatch(getCatalogStatusQuote({ enable: enable, page: page, limit: limit }));
            }
        }
    }, []);
    useEffect(function () {
        if (errorAllQuote) {
            showErrorToast(errorAllQuote, setSeeToast, t);
        }
    }, [errorAllQuote]);
    useEffect(function () {
        if (errorGetCatalogStatusQuote) {
            showErrorToast(errorGetCatalogStatusQuote, setSeeToast, t);
        }
    }, [errorGetCatalogStatusQuote]);
    useEffect(function () {
        if (errorBranches) {
            showErrorToast(errorBranches, setSeeToast, t);
        }
    }, [errorBranches]);
    useEffect(function () {
        if (errorExecuteReports && isExecuteReportType(reportType)) {
            showErrorToast(errorExecuteReports, setSeeToast, t);
        }
    }, [errorExecuteReports]);
    useEffect(function () {
        var quoteList = getQuoteList(responseAllQuote);
        if (quoteList.length > 0 && !isExecuteReportType(reportType)) {
            setDataReportStorybook(quoteList);
        }
    }, [responseAllQuote]);
    useEffect(function () {
        if (Array.isArray(responseExecuteReports) &&
            isExecuteReportType(reportType)) {
            setDataReportStorybook(responseExecuteReports);
        }
    }, [responseExecuteReports]);
    useEffect(function () {
        if (Array.isArray(responseInsurance)) {
            setInsuranceOptionsStorybook(responseInsurance);
        }
    }, [responseInsurance]);
    useEffect(function () {
        if (isInitialMount.current) {
            isInitialMount.current = false;
            return;
        }
        if (nameSearch && !isExecuteReportType(reportType)) {
            getQuoteAll();
        }
        else if (!nameSearch) {
            onCloseSearch();
        }
    }, [nameSearch]);
    useEffect(function () {
        if (Array.isArray(responseBranches)) {
            setBranchesOptionsStorybook(responseBranches);
        }
    }, [responseBranches]);
    var searchFilter = function (term) {
        setNameSearch(term);
    };
    var onCloseSearch = function () {
        setNameSearch("");
        if (isExecuteReportType(reportType)) {
            loadExecuteReportData(startDate, endDate);
            return;
        }
        dispatch(quoteAll({
            clientId: clientId,
            enable: enable,
            catalogStatusQuote: id,
            page: page,
            limit: limit,
            search: "",
        }));
    };
    var getQuoteAll = function () {
        dispatch(quoteAll({
            clientId: clientId,
            enable: enable,
            catalogStatusQuote: id,
            page: page,
            limit: limit,
            search: nameSearch,
        }));
    };
    var setBranchesOptionsStorybook = function (responseBranches) {
        var dataBranches = [];
        responseBranches === null || responseBranches === void 0 ? void 0 : responseBranches.map(function (item) {
            if (item.id && item.name) {
                dataBranches.push({
                    id: item.id,
                    name: item.name,
                    active: false,
                });
            }
        });
        setBranchesOptions(dataBranches);
    };
    var setInsuranceOptionsStorybook = function (responseProject) {
        var dataInsurance = [];
        responseProject === null || responseProject === void 0 ? void 0 : responseProject.map(function (item) {
            if (item.id && item.description) {
                dataInsurance.push({
                    id: item.id,
                    name: item.description,
                    active: false,
                });
            }
        });
        setInsuranceOptions(dataInsurance);
    };
    var mapRowData = function (items) {
        switch (reportType) {
            case "balance-aging":
                return items.map(function (item, index) {
                    var _a;
                    return ({
                        id: (_a = item === null || item === void 0 ? void 0 : item.id) !== null && _a !== void 0 ? _a : index + 1,
                        certificado: item === null || item === void 0 ? void 0 : item["Certificado"],
                        primerNombre: item === null || item === void 0 ? void 0 : item["Nombre"],
                        segundoNombre: "",
                        primerApellido: item === null || item === void 0 ? void 0 : item["Primer Apellido"],
                        segundoApellido: item === null || item === void 0 ? void 0 : item["Segundo Apellido"],
                        cedula: item === null || item === void 0 ? void 0 : item["Cedula"],
                        cuenta: item === null || item === void 0 ? void 0 : item["Cuenta"],
                        tipoCuenta: item === null || item === void 0 ? void 0 : item["Tipo de Cuenta"],
                        fechaEfectiva: (item === null || item === void 0 ? void 0 : item["Fecha Efectiva"])
                            ? formattedDate(item === null || item === void 0 ? void 0 : item["Fecha Efectiva"])
                            : "",
                        prima: (item === null || item === void 0 ? void 0 : item["Prima"]) != null ? "RD$ ".concat(item === null || item === void 0 ? void 0 : item["Prima"]) : "",
                        formaPago: item === null || item === void 0 ? void 0 : item["Forma Pago"],
                        cuotasPendientes: item === null || item === void 0 ? void 0 : item["Cuotas Pendientes"],
                        descripcionProducto: item === null || item === void 0 ? void 0 : item["Descripcion Producto"],
                        ultimoPeriodoFacturado: item === null || item === void 0 ? void 0 : item["Ultimo Periodo Facturado"],
                        rango1_30: item === null || item === void 0 ? void 0 : item["1-30"],
                        rango31_60: item === null || item === void 0 ? void 0 : item["31-60"],
                        rango61_90: item === null || item === void 0 ? void 0 : item["61-90"],
                        polizaProtegida: item === null || item === void 0 ? void 0 : item["Poliza Protegida"],
                    });
                });
            case "upcoming-cancellations":
                return items.map(function (item, index) {
                    var _a;
                    return ({
                        id: (_a = item === null || item === void 0 ? void 0 : item.id) !== null && _a !== void 0 ? _a : index + 1,
                        certificado: item === null || item === void 0 ? void 0 : item["Certificado"],
                        nombreProducto: item === null || item === void 0 ? void 0 : item["Nombre Producto"],
                        fechaEmision: (item === null || item === void 0 ? void 0 : item["Fecha Emision"])
                            ? formattedDate(item === null || item === void 0 ? void 0 : item["Fecha Emision"])
                            : "",
                        nombre: item === null || item === void 0 ? void 0 : item["Nombre"],
                        apellido: item === null || item === void 0 ? void 0 : item["Apellido"],
                        cedula: item === null || item === void 0 ? void 0 : item["Cedula Cliente"],
                        nombreProductoApap: item === null || item === void 0 ? void 0 : item["Nombre Producto APAP"],
                        noProductoApap: item === null || item === void 0 ? void 0 : item["No Producto APAP"],
                        prima: (item === null || item === void 0 ? void 0 : item["Prima"]) != null ? "RD$ ".concat(item === null || item === void 0 ? void 0 : item["Prima"]) : "",
                        modalidadPago: item === null || item === void 0 ? void 0 : item["Modalidad Pago"],
                        estado: item === null || item === void 0 ? void 0 : item["Desc Estatus"],
                        nombreEmpleado: item === null || item === void 0 ? void 0 : item["Nombre Empleado"],
                        posicionEmpleado: item === null || item === void 0 ? void 0 : item["Posicion Empleado"],
                        usuario: item === null || item === void 0 ? void 0 : item["Usuario"],
                        sucursal: item === null || item === void 0 ? void 0 : item["Sucursal"],
                    });
                });
            case "health-preferential":
                return items.map(function (item, index) {
                    var _a;
                    return ({
                        id: (_a = item === null || item === void 0 ? void 0 : item.id) !== null && _a !== void 0 ? _a : index + 1,
                        noCertificado: item === null || item === void 0 ? void 0 : item.polizaid,
                        nombreProductoBanca: item === null || item === void 0 ? void 0 : item.descripcion,
                        fechaEmision: (item === null || item === void 0 ? void 0 : item.fechaefectiva)
                            ? formattedDate(item === null || item === void 0 ? void 0 : item.fechaefectiva)
                            : "",
                        fechaActualizacion: (item === null || item === void 0 ? void 0 : item.fechaaccionusuario)
                            ? formattedDate(item === null || item === void 0 ? void 0 : item.fechaaccionusuario)
                            : "",
                        tipoActualizacion: item === null || item === void 0 ? void 0 : item.tipoactualizacion,
                        tipoAsegurado: item === null || item === void 0 ? void 0 : item.tipoasegurado,
                        nombre: item === null || item === void 0 ? void 0 : item.nombre,
                        apellido: item === null || item === void 0 ? void 0 : item.apellido,
                        cedula: item === null || item === void 0 ? void 0 : item.nodocumento,
                        nombreProductoApap: item === null || item === void 0 ? void 0 : item.descripcion,
                        noProductoPrima: item === null || item === void 0 ? void 0 : item.nocuenta,
                        prima: (item === null || item === void 0 ? void 0 : item.premium) != null ? "RD$ ".concat(item === null || item === void 0 ? void 0 : item.premium) : "",
                        estado: item === null || item === void 0 ? void 0 : item.estado,
                        nombreEmpleado: item === null || item === void 0 ? void 0 : item.nombreempleado,
                        usuario: item === null || item === void 0 ? void 0 : item.usuario,
                        sucursal: item === null || item === void 0 ? void 0 : item.sucursal,
                        fechaCancelacion: (item === null || item === void 0 ? void 0 : item.fechacancelacion) && (item === null || item === void 0 ? void 0 : item.fechacancelacion) !== ""
                            ? formattedDate(item === null || item === void 0 ? void 0 : item.fechacancelacion)
                            : "",
                        motivoCancelacion: item === null || item === void 0 ? void 0 : item.motivocancelacion,
                    });
                });
            case "travel-assistance":
                return items.map(function (item, index) {
                    var _a;
                    return ({
                        id: (_a = item === null || item === void 0 ? void 0 : item.id) !== null && _a !== void 0 ? _a : index + 1,
                        on: item === null || item === void 0 ? void 0 : item.polizaid,
                        fecha: (item === null || item === void 0 ? void 0 : item.fechaefectiva) ? formattedDate(item === null || item === void 0 ? void 0 : item.fechaefectiva) : "",
                        noVoucher: item === null || item === void 0 ? void 0 : item.voucher,
                        nombre: item === null || item === void 0 ? void 0 : item.nombrea,
                        apellido: item === null || item === void 0 ? void 0 : item.apellidoa,
                        fechaNacimiento: (item === null || item === void 0 ? void 0 : item.fechanacimiento)
                            ? formattedDate(item === null || item === void 0 ? void 0 : item.fechanacimiento)
                            : "",
                        telefono: (item === null || item === void 0 ? void 0 : item.telefonocasa) || (item === null || item === void 0 ? void 0 : item.telefonomovil) || (item === null || item === void 0 ? void 0 : item.telefonooficina),
                        correo: item === null || item === void 0 ? void 0 : item.correoelectronico,
                        cedula: item === null || item === void 0 ? void 0 : item.secuencia,
                        noPasajeros: item === null || item === void 0 ? void 0 : item.nopasajeros,
                        fechaSalida: (item === null || item === void 0 ? void 0 : item.startdate) ? formattedDate(item === null || item === void 0 ? void 0 : item.startdate) : "",
                        fechaRegreso: (item === null || item === void 0 ? void 0 : item.enddate) ? formattedDate(item === null || item === void 0 ? void 0 : item.enddate) : "",
                        status: item === null || item === void 0 ? void 0 : item.cnfestatuspolizaid,
                        noReferencia: item === null || item === void 0 ? void 0 : item.voucher,
                        tipoCuenta: item === null || item === void 0 ? void 0 : item.descriptionshort,
                        noCuenta: item === null || item === void 0 ? void 0 : item.numberaccount,
                        montoPrimaUSD: (item === null || item === void 0 ? void 0 : item.premium) != null ? "USD ".concat(item === null || item === void 0 ? void 0 : item.premium) : "",
                        montoPrimaRD: (item === null || item === void 0 ? void 0 : item.primiunpesos) != null ? "RD$ ".concat(item === null || item === void 0 ? void 0 : item.primiunpesos) : "",
                        tasa: item === null || item === void 0 ? void 0 : item.exchangerate,
                    });
                });
            case "first-fee":
                return items.map(function (item, index) {
                    var _a;
                    return ({
                        id: (_a = item === null || item === void 0 ? void 0 : item.id) !== null && _a !== void 0 ? _a : index + 1,
                        poliza: item === null || item === void 0 ? void 0 : item.PolizaId,
                        nombre: item === null || item === void 0 ? void 0 : item.NombreA,
                        primerApellido: item === null || item === void 0 ? void 0 : item.ApellidoA,
                        segundoApellido: item === null || item === void 0 ? void 0 : item.ApellidoB,
                        secuencia: item === null || item === void 0 ? void 0 : item.Secuencia,
                        cuenta: item === null || item === void 0 ? void 0 : item.NumeroCuenta,
                        tipoCuenta: item === null || item === void 0 ? void 0 : item.TipoCuenta,
                        fechaEfectiva: (item === null || item === void 0 ? void 0 : item.FechaEfectiva)
                            ? formattedDate(item === null || item === void 0 ? void 0 : item.FechaEfectiva)
                            : "",
                        monto: (item === null || item === void 0 ? void 0 : item.Monto) != null ? "RD$ ".concat(item === null || item === void 0 ? void 0 : item.Monto) : "",
                        producto: item === null || item === void 0 ? void 0 : item.Producto,
                        codigoTransaccion: item === null || item === void 0 ? void 0 : item.CodigoTransaccion,
                    });
                });
            default: // "sales"
                return items.map(function (item) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
                    return ({
                        id: item === null || item === void 0 ? void 0 : item.id,
                        certificate: (item === null || item === void 0 ? void 0 : item.policyId) ? (_a = item === null || item === void 0 ? void 0 : item.policyId) === null || _a === void 0 ? void 0 : _a.code : item.code,
                        product: (_b = item === null || item === void 0 ? void 0 : item.productId) === null || _b === void 0 ? void 0 : _b.description,
                        creationDate: (item === null || item === void 0 ? void 0 : item.policyId)
                            ? formattedDate((_c = item === null || item === void 0 ? void 0 : item.policyId) === null || _c === void 0 ? void 0 : _c.effectiveFrom)
                            : formattedDate(item === null || item === void 0 ? void 0 : item.creationDate),
                        names: "".concat(item === null || item === void 0 ? void 0 : item.firstNameA, " ").concat(item === null || item === void 0 ? void 0 : item.firstNameB),
                        lastNames: "".concat(item === null || item === void 0 ? void 0 : item.lastNameA, " ").concat(item === null || item === void 0 ? void 0 : item.lastNameB),
                        identificationNumber: item === null || item === void 0 ? void 0 : item.numberId,
                        paymentType: (_d = item === null || item === void 0 ? void 0 : item.customerAccount) === null || _d === void 0 ? void 0 : _d.accountType.description,
                        accountNumber: (_e = item === null || item === void 0 ? void 0 : item.customerAccount) === null || _e === void 0 ? void 0 : _e.accountNumber,
                        prime: "RD$ ".concat((_f = item === null || item === void 0 ? void 0 : item.customerAccount) === null || _f === void 0 ? void 0 : _f.amount),
                        status: (_g = item === null || item === void 0 ? void 0 : item.catalogStatusQuote) === null || _g === void 0 ? void 0 : _g.description,
                        userName: (_h = item === null || item === void 0 ? void 0 : item.user) === null || _h === void 0 ? void 0 : _h.fullName,
                        user: (_j = item === null || item === void 0 ? void 0 : item.user) === null || _j === void 0 ? void 0 : _j.email,
                        branch: (_k = item === null || item === void 0 ? void 0 : item.branchData) === null || _k === void 0 ? void 0 : _k.name,
                        cancellationDate: ((_l = item === null || item === void 0 ? void 0 : item.catalogCancellation) === null || _l === void 0 ? void 0 : _l.createdAt) &&
                            formattedDate((_m = item === null || item === void 0 ? void 0 : item.catalogCancellation) === null || _m === void 0 ? void 0 : _m.createdAt),
                        reasonCancellation: (_o = item === null || item === void 0 ? void 0 : item.catalogCancellation) === null || _o === void 0 ? void 0 : _o.description,
                        insuranceCarrier: (_p = item === null || item === void 0 ? void 0 : item.sponsor) === null || _p === void 0 ? void 0 : _p.name,
                    });
                });
        }
    };
    var setDataReportStorybook = function (data) {
        var dataR = mapRowData(data);
        setRows(dataR);
        if (isExecuteReportType(reportType)) {
            dispatch(executeReportsClearData());
        }
        else {
            dispatch(quoteAllClearData());
        }
    };
    var onClickDownload = function (item) {
        setIsLoading(true);
        downloadReports(item, clientId, enable, page, limit, id ? id : "", startDate, endDate, fields, labelFields)
            .then(function () {
            setSeeToast({
                show: true,
                message: t("salesReport.downloadFile"),
                type: typeAlert.success,
            });
        })
            .catch(function (error) {
            console.error("Error al descargar el archivo:", error);
        })
            .finally(function () {
            setIsLoading(false);
        });
    };
    var filterStatus = function (item) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var newStartDate = formattedDateWithTime((_a = item === null || item === void 0 ? void 0 : item.dateRange) === null || _a === void 0 ? void 0 : _a.startDate) === "undefined" ||
            formattedDateWithTime((_b = item === null || item === void 0 ? void 0 : item.dateRange) === null || _b === void 0 ? void 0 : _b.startDate) === "null" ||
            formattedDateWithTime((_c = item === null || item === void 0 ? void 0 : item.dateRange) === null || _c === void 0 ? void 0 : _c.startDate) === "NA"
            ? ""
            : formattedDateWithTime((_d = item === null || item === void 0 ? void 0 : item.dateRange) === null || _d === void 0 ? void 0 : _d.startDate);
        var newEndDate = formattedDateWithTime((_e = item === null || item === void 0 ? void 0 : item.dateRange) === null || _e === void 0 ? void 0 : _e.endDate) === "undefined" ||
            formattedDateWithTime((_f = item === null || item === void 0 ? void 0 : item.dateRange) === null || _f === void 0 ? void 0 : _f.endDate) === "null" ||
            formattedDateWithTime((_g = item === null || item === void 0 ? void 0 : item.dateRange) === null || _g === void 0 ? void 0 : _g.endDate) === "NA"
            ? ""
            : formattedDateWithTime((_h = item === null || item === void 0 ? void 0 : item.dateRange) === null || _h === void 0 ? void 0 : _h.endDate);
        setStartDate(newStartDate);
        setEndDate(newEndDate);
        if (isExecuteReportType(reportType)) {
            loadExecuteReportData(newStartDate, newEndDate);
            return;
        }
        var idBranch = item === null || item === void 0 ? void 0 : item.branch.map(function (item) { return item.id; }).join(",");
        var idInsurance = item === null || item === void 0 ? void 0 : item.insurance.map(function (item) { return item.id; }).join(",");
        dispatch(quoteAll({
            clientId: clientId,
            enable: enable,
            catalogStatusQuote: id,
            creationDateStart: newStartDate,
            creationDateEnd: newEndDate,
            branches: idBranch,
            projectIds: idInsurance,
            page: page,
            limit: limit,
        }));
    };
    var onClickBack = function () {
        if (reportType === "sales") {
            dispatch(getCatalogStatusQuoteClearData());
        }
        navigate("/reportsPage");
    };
    var resolveTitle = function () {
        if (reportType !== "sales")
            return getReportTitle(reportType);
        if (id === idSalesCompleted)
            return "Reporte de ventas completadas";
        if (id === idSalesCanceled)
            return "Reporte de ventas canceladas";
        return "Reporte de ventas";
    };
    var isLoadingData = isExecuteReportType(reportType)
        ? loadingExecuteReports
        : loadingAllQuote || loadingGetCatalogStatusQuote;
    return (_jsxs(React.Fragment, { children: [_jsx(AlertLoadingHeader, { loading: isLoadingData || isLoadin || loadingBranches, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, titleLoading: isLoadin
                    ? "Descargando archivo"
                    : isExecuteReportType(reportType)
                        ? "Cargando ".concat(getReportTitle(reportType), ".")
                        : "Cargando Pólizas." }), _jsx(CompletedView, { reportType: reportType, title: resolveTitle(), searchFilter: searchFilter, onCloseSearch: onCloseSearch, branchOptions: branchesOptions, rows: rows, filterStatus: filterStatus, id: id, downloadFile: onClickDownload, insuranceOptions: insuranceOptions, onClickBack: onClickBack, description: description })] }));
};
